export default __webpack_public_path__ + "static/media/Sass.73b6baf2.png";